import {
  LEGAL_REPRESENTATIVE_CITY,
  LEGAL_REPRESENTATIVE_COUNTRY,
  LEGAL_REPRESENTATIVE_DATE_OF_BIRTH,
  LEGAL_REPRESENTATIVE_FIRST_NAME,
  LEGAL_REPRESENTATIVE_MIDDLE_NAME,
  LEGAL_REPRESENTATIVE_LAST_NAME,
  LEGAL_REPRESENTATIVE_NATIONALITY,
  LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES,
  LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON,
  LEGAL_REPRESENTATIVE_SALUTATION,
  LEGAL_REPRESENTATIVE_STATE,
  LEGAL_REPRESENTATIVE_STREET_NAME,
  LEGAL_REPRESENTATIVE_STREET_NUMBER,
  LEGAL_REPRESENTATIVE_ZIP_CODE,
  LEGAL_REPRESENTATIVE_PAN_CARD_DOCUMENT,
  LEGAL_REPRESENTATIVE_PASSPORT_DOCUMENT,
  LEGAL_REPRESENTATIVE_UTILITY_BILL_DOCUMENT,
  LEGAL_REPRESENTATIVE_VISA_DOCUMENT,
  LEGAL_REPRESENTATIVE_EMAIL_ADDRESS,
  LEGAL_REPRESENTATIVE_AADHAAR_NUMBER,
  LEGAL_REPRESENTATIVE_DIRECTOR_IDENTIFICATION_NUMBER,
  LEGAL_REPRESENTATIVE_POSITION,
  LEGAL_REPRESENTATIVE_TYPE_OF_REPRESENTATION,
  LEGAL_REPRESENTATIVE_IS_SIGNATORY,
} from '@modifi/plugin-onboarding'

import {UploadedDocument} from '../../../types/common'

export const LEGAL_REPRESENTATIVES_DOCUMENT_INPUT_FIELD_NAMES: string[] = [
  LEGAL_REPRESENTATIVE_PASSPORT_DOCUMENT,
  LEGAL_REPRESENTATIVE_PAN_CARD_DOCUMENT,
  LEGAL_REPRESENTATIVE_UTILITY_BILL_DOCUMENT,
  LEGAL_REPRESENTATIVE_VISA_DOCUMENT,
]

export const LEGAL_REPRESENTATIVES_PERSON_INPUT_FIELD_NAMES: string[] = [
  LEGAL_REPRESENTATIVE_SALUTATION,
  LEGAL_REPRESENTATIVE_FIRST_NAME,
  LEGAL_REPRESENTATIVE_MIDDLE_NAME,
  LEGAL_REPRESENTATIVE_LAST_NAME,
  LEGAL_REPRESENTATIVE_STREET_NAME,
  LEGAL_REPRESENTATIVE_STREET_NUMBER,
  LEGAL_REPRESENTATIVE_COUNTRY,
  LEGAL_REPRESENTATIVE_CITY,
  LEGAL_REPRESENTATIVE_STATE,
  LEGAL_REPRESENTATIVE_ZIP_CODE,
  LEGAL_REPRESENTATIVE_DATE_OF_BIRTH,
  LEGAL_REPRESENTATIVE_EMAIL_ADDRESS,
  LEGAL_REPRESENTATIVE_NATIONALITY,
  LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES,
  LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON,
  LEGAL_REPRESENTATIVE_AADHAAR_NUMBER,
]

export const LEGAL_REPRESENTATIVES_ROLE_INPUT_FIELD_NAMES: string[] = [
  LEGAL_REPRESENTATIVE_DIRECTOR_IDENTIFICATION_NUMBER,
  LEGAL_REPRESENTATIVE_POSITION,
  LEGAL_REPRESENTATIVE_TYPE_OF_REPRESENTATION,
  LEGAL_REPRESENTATIVE_IS_SIGNATORY,
]

export const FIELD_NAME_TO_PROPERTY_NAME_MAPPING: Record<string, string> = {}

export type LegalRepresentativeFormData = {
  [LEGAL_REPRESENTATIVE_AADHAAR_NUMBER]?: string
  [LEGAL_REPRESENTATIVE_CITY]?: string
  [LEGAL_REPRESENTATIVE_COUNTRY]?: string
  [LEGAL_REPRESENTATIVE_DATE_OF_BIRTH]?: string
  [LEGAL_REPRESENTATIVE_DIRECTOR_IDENTIFICATION_NUMBER]?: string
  [LEGAL_REPRESENTATIVE_EMAIL_ADDRESS]?: string
  [LEGAL_REPRESENTATIVE_FIRST_NAME]?: string
  [LEGAL_REPRESENTATIVE_MIDDLE_NAME]?: string
  [LEGAL_REPRESENTATIVE_LAST_NAME]?: string
  [LEGAL_REPRESENTATIVE_NATIONALITY]?: string
  [LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES]?: string[]
  [LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH]?: string
  [LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED]?: boolean
  [LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON]?: string
  [LEGAL_REPRESENTATIVE_POSITION]?: string
  [LEGAL_REPRESENTATIVE_SALUTATION]?: string
  [LEGAL_REPRESENTATIVE_STATE]?: string
  [LEGAL_REPRESENTATIVE_STREET_NAME]?: string
  [LEGAL_REPRESENTATIVE_STREET_NUMBER]?: string
  [LEGAL_REPRESENTATIVE_TYPE_OF_REPRESENTATION]?: string
  [LEGAL_REPRESENTATIVE_ZIP_CODE]?: string
  [LEGAL_REPRESENTATIVE_PAN_CARD_DOCUMENT]?: UploadedDocument[]
  [LEGAL_REPRESENTATIVE_PASSPORT_DOCUMENT]?: UploadedDocument[]
  [LEGAL_REPRESENTATIVE_VISA_DOCUMENT]?: UploadedDocument[]
  [LEGAL_REPRESENTATIVE_UTILITY_BILL_DOCUMENT]?: UploadedDocument[]
}

export const LEGAL_REP_ROLES_PAGE_INPUT_FIELDS: string[] = [
  LEGAL_REPRESENTATIVE_DIRECTOR_IDENTIFICATION_NUMBER,
  LEGAL_REPRESENTATIVE_POSITION,
  LEGAL_REPRESENTATIVE_TYPE_OF_REPRESENTATION,
  LEGAL_REPRESENTATIVE_AADHAAR_NUMBER,
  LEGAL_REPRESENTATIVE_PASSPORT_DOCUMENT,
  LEGAL_REPRESENTATIVE_VISA_DOCUMENT,
  LEGAL_REPRESENTATIVE_UTILITY_BILL_DOCUMENT,
  LEGAL_REPRESENTATIVE_PAN_CARD_DOCUMENT,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
]
